import * as Constant from '../../constant';
import * as Action from '../action';

const initialState = {
  downloadingVendors: false,
  filters: {
    [Constant.TABLE_FIELD_MASTER_VENDOR_ID]: '',
    [Constant.TABLE_FIELD_MASTER_VENDOR_VENDOR_ID]: '',
    [Constant.TABLE_FIELD_MASTER_VENDOR_VENDOR_NAME]: '',
  },
  sortField: '',
  sortDirection: '',
  activePage: 1,
  pageSize: 5,
  selectedVendorId: null,
  dialogAddStatus: false,
  dialogEditStatus: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_MASTER_VENDOR_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.value,
        },
      };
    }
    case Action.SET_MASTER_VENDOR_PAGING: {
      return { ...state, ...action.value };
    }
    case Action.SET_MASTER_VENDOR_SORT: {
      return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
    }
    case Action.SET_MASTER_VENDOR_ADD_DIALOG_STATUS: {
      return { ...state, dialogAddStatus: action.value };
    }
    case Action.SET_MASTER_VENDOR_DETAIL_DIALOG_STATUS: {
      return { ...state, dialogEditStatus: action.value };
    }
    case Action.SET_MASTER_VENDOR_SELECTED_ID: {
      return { ...state, selectedVendorId: action.value };
    }
    case Action.DOWNLOADING_VENDOR_LIST: {
      return { ...state, downloadingVendors: action.value };
    }
    default: {
      return state;
    }
  }
};
